/**
 * @param {HTMLInputElement[]} inputs
 * @returns {string}
 */
export default function getCheckedValues(inputs) {
  return inputs
    .reduce(
      (prev, curr) => [...prev, ...(curr.checked ? [curr.value] : [])],
      []
    )
    .join('、');
}
